import { DetailItem } from "./DetailItem";
import { DetailFileDownload } from "./DetailFileDownload";

import { showDate, fieldChanged } from "../helpers";

const DetailLabelKeysToCells = (obj: Object, data: Object, wideLabel: boolean = false, highlightChanges: boolean = false) => {
    
  if (! (data && obj && Object.keys(obj).length > 0)) return null;

  const _keys: Array<string> = [];
  Object.keys(obj).forEach((key: string) => {
    //@ts-ignore    
    if (data.hasOwnProperty(key) && data[key]) {
      //@ts-ignore    
      _keys.push(key);            
    }
  })

  if (_keys.length === 0) {
    return null;
  }
  
  return (
  //@ts-ignore
  _keys.map((key: string, idx: number) => (      
    //@ts-ignore
    <DetailItem key={`labelkey${key}-${idx}`} labelText={obj[key]} content={`${data[key]}`} wideLabel={wideLabel} hasChanged={highlightChanges && fieldChanged(data, key)}/>
  ))
  )
}

const DetailDataKeyToFile = (key : string, label : string, data: Object, wideLabel: boolean = false, setscoOnly: boolean = true) => {
  //@ts-ignore
  if (! (data && key && data.hasOwnProperty(key) && data[key] && (! data?.deleted))) return null;
  return (
    //@ts-ignore
    <DetailFileDownload labelText={label} file={data[key]} wideLabel={wideLabel} setscoOnly={setscoOnly} />
  )
}

const DetailLabelKeysToFiles = (obj: Object, data: Object, wideLabel: boolean = false, setscoOnly: boolean = true, highlightChanges: boolean = false) => {
  if (! (data && obj && Object.keys(obj).length > 0)) return null;

  const _keys: Array<string> = [];
  Object.keys(obj).forEach((key: string, idx: number) => {
    //@ts-ignore    
    if (data.hasOwnProperty(key) && data[key]) {
      //@ts-ignore    
      _keys.push(key);            
    }
  })

  if (_keys.length === 0) {
    return null;
  }

  return (
  _keys.map((key: string, idx: number) => (
    //@ts-ignore
    <DetailFileDownload key={`labelkey${key}-${idx}`} labelText={obj[key]} file={data[key]} wideLabel={wideLabel} setscoOnly={setscoOnly} hasChanged={highlightChanges && fieldChanged(data, 'key')}/>        
  ))
  )
}

const DetailLabelKeysToDates = (obj: Object, data: Object, wideLabel: boolean = false) => {
  if (! (data && obj && Object.keys(obj).length > 0)) return null;

  const _keys: Array<string> = [];
  Object.keys(obj).forEach((key: string, idx: number) => {
    //@ts-ignore    
    if (data.hasOwnProperty(key) && data[key]) {
      //@ts-ignore    
      _keys.push(key);            
    }
  })

  if (_keys.length === 0) {
    return null;
  }
  
  return (
  //@ts-ignore
  _keys.map((key: string, idx: number) => (      
    //@ts-ignore        
    <DetailItem key={`labelkey${key}-${idx}`} labelText={obj[key]} wideLabel={wideLabel}>{showDate(data[key])}</DetailItem>
  ))
  )
}

export {
    DetailDataKeyToFile,
    DetailLabelKeysToCells,
    DetailLabelKeysToFiles,
    DetailLabelKeysToDates
}